import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { Share } from '@ifeng/ui_pc_share';
import LazyLoad from '@ifeng/ui_pc_lazyLoad';
import { addEventListener } from '@ifeng/ui_base';
import Ad from '@ifeng/ui_pc_ad';
import Loadable from 'react-loadable';
import styles from './index.css';
import ArticleContent from '../../../../components/articleContent/';
import SlideArea from '../slideArea/';

const LoadComment = Loadable({
    loader: () => import('@ifeng/ui_pc_comment'),
    loading() {
        return <div />;
    },
});

const ArticleArea = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            articleData: PropTypes.object,
            pluginData: PropTypes.object,
            contentAdData: PropTypes.object,
            type: PropTypes.string,
        };

        unlistenerHandleWindowScroll = null; // 事件解绑
        top = 0;
        bottomSharePos = 0;
        state = {
            leftShareShow: true, // 左侧分享是否显示
        };

        getElementPageTop = element => {
            let actualTop = element.offsetTop;
            let parent = element.offsetParent;
            const screenHeight = window.screen.height;

            while (parent != null) {
                actualTop += parent.offsetTop + (parent.offsetHeight - parent.clientHeight) / 2;
                parent = parent.offsetParent;
            }

            return actualTop - screenHeight;
        };

        // 判断返回顶部按钮的显示隐藏
        handleWindowScroll = () => {
            this.bottomSharePos = this.getElementPageTop(this.refs.bottomShare);
            this.top = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

            if (this.top > this.bottomSharePos) {
                this.setState({
                    leftShareShow: false,
                });
            } else {
                this.setState({
                    leftShareShow: true,
                });
            }
        };

        componentDidMount() {
            this.unlistenerHandleWindowScroll = addEventListener(window, 'scroll', this.handleWindowScroll);
        }

        componentWillUnmount() {
            this.unlistenerHandleWindowScroll();
        }

        render() {
            const {
                articleData: {
                    commentUrl,
                    skey,
                    pcUrl,
                    allowComment,
                    contentData,
                    title = '',
                    summary = '',
                    imagesInContent,
                },
                pluginData,
                contentAdData: { ad_content_banner1, ad_content_banner2 },
                type,
            } = this.props;

            const { leftShareShow } = this.state;

            const bottomShareConfig = {
                items: ['sina', 'wechat', 'cof', 'qqzone'],
                display: 'hover',
                hover: 'hover',
                type: 'horizontal',
                methods: 'hover',
                tooltip: 'top',
            };

            const leftShareConfig = {
                items: ['sina', 'wechat', 'cof', 'qqzone'],
                display: 'normal',
                hover: 'hover',
                type: 'vertical',
                methods: 'hover',
                tooltip: 'left',
            };

            const shareInfo = {
                url: encodeURI(window.location.href),
                title: encodeURI(title),
                summery: encodeURI(summary),
                picUrl:
                    (Object.prototype.toString.call(imagesInContent) === '[object Array]' &&
                        imagesInContent[0] &&
                        imagesInContent[0].url) ||
                    '',
            };

            const commentConfig = {
                // 文章单页的页面地址
                docUrl: commentUrl,
                // 文章的标题
                docTitle: title,
                // 文章评论的skey，这个是在后端生成好后给到前端的
                skey,
                // 兼容以后的专题评论
                speUrl: '',
                // 文章pc的页面地址
                pcUrl,
                // 获取评论内容接口
                cmtNumUrl: '//comment.ifeng.com/get.php',
                // 评论内容字数长度
                cmtLength: 1000,
                // 提交评论内容接口
                cmtPostUrl: '//comment.ifeng.com/post.php',
                // 最热评论数量
                hotLimit: 2,
                // 推荐评论接口
                cmtVoteUrl: '//comment.ifeng.com/vote.php',
                // 现实回复的楼层
                replyLimit: 3,
                // 举报提交接口
                jubUrl: '//comment.ifeng.com/report',
                // 举报次数，便于每次回调函数名不同
                jubNum: 0,
                // 是否是评论详情页面
                isComment: false,
                // 是否允许评论
                allowComment,
                order: 'both', // 'uptimes' 按热度排序，'create_time' 按时间排序， 'both', 两者同时存在
                options: 1, // 0 先显示最新，后显示最热，1 反之，此配置在 order 是 both 的情况下才生效
                recentLimit: 2, // 最近评论数量
                recentReplyLimit: 3, // 最近评论数量显示回复的楼层
            };

            return (
                <Fragment>
                    {type === 'article' ? <ArticleContent content={contentData} pluginData={pluginData} /> : null}
                    {type === 'slide' ? <SlideArea slideData={contentData} /> : null}
                    <p className={styles.alarm}>本文来自大风号，仅代表大风号自媒体观点。</p>
                    <div className={styles.articleBottomShare} ref="bottomShare">
                        <Share config={bottomShareConfig} shareInfo={shareInfo} />
                    </div>
                    <Ad content={ad_content_banner1} styleName={styles.ad} />
                    {leftShareShow ? (
                        <div className={styles.articleLeftShare}>
                            <Share config={leftShareConfig} shareInfo={shareInfo} />
                        </div>
                    ) : null}
                    {allowComment ? (
                        <div className={styles.commentsBox}>
                            <LazyLoad>
                                <LoadComment articleInfo={commentConfig} />
                            </LazyLoad>
                        </div>
                    ) : null}
                    <Ad content={ad_content_banner2} styleName={styles.ad} />
                </Fragment>
            );
        }
    },
);

export default ArticleArea;
